$(() => {
  $('[data-form-submit-on-change]').on('change', event => {
    var form = $(event.target).closest('form');
    form.submit();
  });
});
